import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { DateRangeCard } from "../Common/DateRangeCard"

import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import axios from "axios"
import { API_URL } from "../../../constants/constants"
import { FiltersCard } from "../../../components/Common/FiltersCard"

const Transactions = props => {
  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [transaction, setTransaction] = useState([])
  const [toDate, setToDate] = useState("")
  const [fromDate, setFromDate] = useState("")
  useEffect(() => {
    call()
  }, [props.userId])

  const call = () => {
    var id = JSON.parse(localStorage.getItem("user"))?.user?.id
    axios({
      method: "get",
      url: `${API_URL}/admin/transaction-list/${props.userId}?to=${toDate}&from=${fromDate}`,
    })
      .then(function (response) {
        console.log(response?.data?.data)
        setTransaction(response?.data?.data)
      })
      .catch(function (response) {})
  }
  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: transaction.length,
    custom: true,
  }
  const { SearchBar } = Search

  const column = [
    {
      dataField: "created_at",
      text: "Date",
      sort: true,
      formatter: (cell, row) => {
        const formatDateWithTimeZone = (dateString) => {
          const date = new Date(Date.parse(dateString));
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          });
          // Capitalize AM/PM
          return formattedDate.replace(/(am|pm)/gi, (match) => match.toUpperCase());
        };

        return (
          <>
            {row?.payment_types == "Tola"
              ? formatDateWithTimeZone(row?.success_at)
              : formatDateWithTimeZone(row?.date)}
          </>
        );
      }
    },
    {
      dataField: "payment_type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "reference_id",
      text: "Reference",
      sort: true,
    },
    {
      dataField: "operatorreference",
      text: "Operator Reference",
      sort: true,
    },
    {
      dataField: "customerreference",
      text: "Customer Reference",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => (
        <>
          {
            Number(Number(row?.amount).toFixed(2)).toLocaleString("en-GB")
            // (row?.payment_types=="Tola") ? Number(Number(row?.amount).toFixed(2)).toLocaleString('en-GB') : Number(Number(row?.amount/100).toFixed(2)).toLocaleString('en-GB')
          }
        </>
      ),
    },
    {
      dataField: "success",
      text: "Status",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row?.payment_types == "Tola"
            ? row?.txn_status && row?.txn_status != "200"
              ? "False"
              : "True"
            : row?.success}
        </>
      ),
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const defaultSorted = [
    {
      dataField: "date",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <FiltersCard
        toDate={toDate}
        fromDate={fromDate}
        setToDate={d => setToDate(d)}
        setFromDate={d => setFromDate(d)}
        call={() => {
          call()
        }}
        notDisplayFilter={true}
        hideShowType={false}
      />

      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Daily Transactions</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={column}
            data={transaction}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={transaction}
                columns={column}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            // selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(Transactions)
